import React from 'react';
import { CortisolSwitchPage } from './pages/CortisolSwitchPage';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <>
      <CortisolSwitchPage data-id="element-0" />
      <RecentPurchaseToast data-id="element-1" />
    </>;
}